module.exports = __webpack_public_path__ + "img/qr_gzh.216f0055.png";